module.exports = __webpack_public_path__ + "media/images/weather-icons/fill/overcast-45e9e87bb18e1c2ae6b3db32296071b0.svg";